var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13V21",
    stroke: "#FDA214",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99985 14.9002C3.25689 14.1412 2.69642 13.223 2.36089 12.2152C2.02535 11.2074 1.92356 10.1365 2.06321 9.08354C2.20287 8.0306 2.58031 7.02324 3.16695 6.13778C3.75358 5.25231 4.53403 4.51196 5.44918 3.97279C6.36433 3.43363 7.39018 3.10979 8.44902 3.02582C9.50786 2.94184 10.5719 3.09993 11.5606 3.4881C12.5493 3.87627 13.4367 4.48435 14.1556 5.26628C14.8745 6.0482 15.406 6.98347 15.7099 8.00124H17.4999C18.4654 8.00113 19.4053 8.31156 20.1808 8.88668C20.9564 9.4618 21.5264 10.2711 21.8066 11.195C22.0869 12.119 22.0625 13.1086 21.7372 14.0176C21.4118 14.9267 20.8027 15.707 19.9999 16.2432",
    stroke: "#FDA214",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17L12 13L16 17",
    stroke: "#FDA214",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSidebar);
export default __webpack_public_path__ + "static/media/uploadSidebar.b6e43d469a5c13984e3e950739594504.svg";
export { ForwardRef as ReactComponent };